"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichTextItemIndexReferenceWrapper = void 0;
/**
 * This class as a wrapper is required so we can pass
 * index as a reference and not a value
 */
var RichTextItemIndexReferenceWrapper = /** @class */ (function () {
    function RichTextItemIndexReferenceWrapper(index) {
        this.index = index;
    }
    RichTextItemIndexReferenceWrapper.prototype.increment = function () {
        this.index++;
    };
    return RichTextItemIndexReferenceWrapper;
}());
exports.RichTextItemIndexReferenceWrapper = RichTextItemIndexReferenceWrapper;
//# sourceMappingURL=parse-models.js.map